import IntroductionEmbeddedSystems from "../../../../../assets/Courses/embeddedSystemsCourses/introductiontoEmbeddedSystems.webp";
import PracticalCProgramming from "../../../../../assets/Courses/embeddedSystemsCourses/practicalCProgramming.webp";
import PracticalElectronics  from "../../../../../assets/Courses/embeddedSystemsCourses/practicalElectronics.webp";
import LinuxFundamentals from "../../../../../assets/Courses/embeddedSystemsCourses/linuxFundamentals.webp";
import ObjectOrientedProgramming from "../../../../../assets/Courses/embeddedSystemsCourses/objectOrientedProgramming.webp";
import EmbeddedSystemsESP32 from "../../../../../assets/Courses/embeddedSystemsCourses/embeddedSystemswithESP32ESPIDF.webp";
import ARMCortexMProgramming from "../../../../../assets/Courses/embeddedSystemsCourses/armCortexMProgrammingSTM32.webp";
import RealTimeEmbeddedSystems from "../../../../../assets/Courses/embeddedSystemsCourses/realTimeEmbeddedSystemswithFreeRTOS.webp";
import InterruptHandlingEmbeddedSystems from "../../../../../assets/Courses/embeddedSystemsCourses/interruptHandlinginEmbeddedSystems.webp";
import AdvancedPeripherals from "../../../../../assets/Courses/embeddedSystemsCourses/advancedPeripheralsPWMCANLINEthernet.webp";
import EmbeddedSystemsSecurity from "../../../../../assets/Courses/embeddedSystemsCourses/secureBootCybersecurity.webp";
import EmbeddedLinuxDevelopment from "../../../../../assets/Courses/embeddedSystemsCourses/embeddedLinuxDevelopment.webp";
import EmbeddedAI from "../../../../../assets/Courses/embeddedSystemsCourses/embeddedAI.webp";
import IntroductionInternetThings from "../../../../../assets/learnersCourses/iotCourses/introductiontoInternetofThings.webp";

import NetworkingTCPIP from "../../../../../assets/Courses/embeddedSystemsCourses/networkingTCPIPProtocolsRoutingSocketProgramming.webp";
import IoTEmbeddedSystemswithESP32 from "../../../../../assets/learnersCourses/iotCourses/ioTandEmbeddedSystemswithESP32.webp";
import WirelessCommunicationProtocols from "../../../../../assets/Courses/embeddedSystemsCourses/wirelessCommunicationProtocols.webp";
import BuildingIoTApplicationswithSTM32 from "../../../../../assets/Courses/embeddedSystemsCourses/buildingIoTApplicationswithSTM.webp";
import LinuxDeviceDriversKernelDevelopment from "../../../../../assets/Courses/embeddedSystemsCourses/linuxDeviceDriversKernelDevelopment.webp";
import EmbeddedLinuxBootProcess from "../../../../../assets/Courses/embeddedSystemsCourses/embeddedLinuxBootProcessUBootDevelopment.webp";
import YoctoEmbeddedLinuxApplicationDevelopment from "../../../../../assets/Courses/embeddedSystemsCourses/yoctoEmbeddedLinuxApplicationDevelopment.webp";
import RaspberryPiwithEmbeddedLinux from "../../../../../assets/Courses/embeddedSystemsCourses/yoctoEmbeddedLinuxApplicationDevelopment.webp";
import AutomotiveEmbeddedSystems from "../../../../../assets/Courses/embeddedSystemsCourses/automotiveEmbeddedSystemsCommunicationProtocols.webp";
import AUTOSARCUDevelopment from "../../../../../assets/Courses/embeddedSystemsCourses/autosarEcuDevelopmentArchitectureImplementationTesting.webp";
import FunctionalSafetyADAS from "../../../../../assets/Courses/embeddedSystemsCourses/functionalSafetyADASISOAutonomousVehicleSystems.webp";

const EmbeddedSystemsCourses = [
  {
    category: "EMBEDDED",
    learningPath: "Embedded Systems",
    courses: [
  {
    courseId: 1,
    courseTitle: "Introduction to Embedded Systems",
    videoUrl: "67f0fb22e258a25e8f9a1eed",
    image: IntroductionEmbeddedSystems,
    completion: 0
  },
  {
    courseId: 2,
    courseTitle: "Practical C Programming",
    videoUrl: "67f0fbfc0eb36d149aa67a88",
    image: PracticalCProgramming,
    completion: 0
  },
  {
    courseId: 3,
    courseTitle: "Practical Electronics",
    videoUrl: "67f0fc77caa5075d8a6eedde",
    image: PracticalElectronics,
    completion: 0
  },
  {
    courseId: 4,
    courseTitle: "Linux Fundamentals",
    videoUrl: "67f0fceaeb2ffd5834741f95",
    image: LinuxFundamentals,
    completion: 0
  },
  // {
  //     courseId: 4,
  //     courseTitle: "IoT using Raspberry Pi and Python",
  //     videoUrl: "66044b9cdf77f21d16e2c40c",
  //     image: PracticalElectronics,
  //   },
  {
    courseId: 5,
    courseTitle: "Object-Oriented Programming with C++",
    videoUrl: "67f0fd567c760d7d98f4cf61",
    image:  ObjectOrientedProgramming,
    completion: 0
  },
  {
    courseId: 6,
    courseTitle: "Embedded Systems with ESP32 and ESP-IDF Programming",
    videoUrl: "67f0fdd6ef9ded35a3bb8392", 
    image: EmbeddedSystemsESP32,
    completion: 0
  },
  {
    courseId: 7,
    courseTitle: "ARM Cortex-M Programming for Embedded Systems: STM32",
    videoUrl: "67f0fe73c4fd2505bce52199",
    image: ARMCortexMProgramming,
    completion: 0
  },
  {
    courseId: 8,
    courseTitle: "Real-Time Embedded Systems with FreeRTOS",
    videoUrl: "67f0ff4062f75f283817c01d", 
    image: RealTimeEmbeddedSystems,
    completion: 0
  },
  {
    courseId: 9,
    courseTitle: "Interrupt Handling in Embedded Systems",
    videoUrl: "67f0ffdc0eb36d149aa67d14", 
    image: InterruptHandlingEmbeddedSystems,
    completion: 0
  },
  {
    courseId: 10,
    courseTitle: "Advanced Peripherals: PWM, CAN, LIN, Ethernet",
    videoUrl: "67f10070e258a25e8f9a2327", 
    image: AdvancedPeripherals,
    completion: 0
  },
  {
    courseId: 11,
    courseTitle: "Embedded Systems Security: Foundations, Secure Boot, and Cybersecurity",
    videoUrl: "67f10132eb2ffd5834742216", 
    image: EmbeddedSystemsSecurity,
    completion: 0
  },
  {
    courseId: 12,
    courseTitle: "Embedded Linux Development",
    videoUrl: "67f101faef9ded35a3bb8617", 
    image: EmbeddedLinuxDevelopment,
    completion: 0
  },
  {
    courseId: 13,
    courseTitle: "Embedded AI",
    videoUrl: "67f1029cf7ce53773830c300", 
    image: EmbeddedAI,
    completion: 0
  },
]
  }
];

const IoTEmbeddedSystems = [
  {
    category: "EMBEDDED",
    learningPath: "IoT and Embedded Systems",
    courses: [
    {
      courseId: 1,
      courseTitle: "Introduction to Embedded Systems",
      videoUrl: "67f0fb22e258a25e8f9a1eed",
      image: IntroductionEmbeddedSystems,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Practical C Programming",
      videoUrl: "67f0fbfc0eb36d149aa67a88",
      image: PracticalCProgramming,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Introduction to Internet of Things",
      videoUrl: "66e8028064721c6daa143ae8",
      image: IntroductionInternetThings,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "Networking and TCP/IP: Protocols, Routing, and Socket Programming",
      videoUrl: "67f104a77c760d7d98f4d475",
      image: NetworkingTCPIP,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Embedded Systems with ESP32 and ESP-IDF Programming",
      videoUrl: "67f0fdd6ef9ded35a3bb8392",
      image:  EmbeddedSystemsESP32,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "ARM Cortex-M Programming for Embedded Systems: STM32",
      videoUrl: "67f0fe73c4fd2505bce52199", 
      image: ARMCortexMProgramming,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "IoT and Embedded Systems with ESP32",
      videoUrl: "660e7e601e0fac451502fb0c",
      image: IoTEmbeddedSystemswithESP32,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "Wireless Communication Protocols",
      videoUrl: "67f1059ccc31b9138bf6bb3e", 
      image: WirelessCommunicationProtocols,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Building IoT Applications with STM32",
      videoUrl: "67f1063374ddd47d29d982ba", 
      image: BuildingIoTApplicationswithSTM32,
      completion: 0
    },
    ]
  }
  ];

  const EmbeddedLinux = [
    {
      category: "EMBEDDED",
      learningPath: "Embedded Linux and System Development",
      courses: [
    {
      courseId: 1,
      courseTitle: "Introduction to Embedded Systems",
      videoUrl: "67f0fb22e258a25e8f9a1eed",
      image: IntroductionEmbeddedSystems,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Linux Fundamentals",
      videoUrl: "67f0fceaeb2ffd5834741f95",
      image: LinuxFundamentals,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Embedded Linux Development",
      videoUrl: "67f101faef9ded35a3bb8617",
      image: EmbeddedLinuxDevelopment,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "Linux Device Drivers and Kernel Development",
      videoUrl: "67f1079d4ce5fc4a5ea17547",
      image: LinuxDeviceDriversKernelDevelopment,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Embedded Linux Boot Process & U-Boot Development",
      videoUrl: "67f10838e2dc692b2a0e50cc",
      image:  EmbeddedLinuxBootProcess,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Yocto & Embedded Linux Application Development",
      videoUrl: "67f108be74ddd47d29d98407", 
      image: YoctoEmbeddedLinuxApplicationDevelopment,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Raspberry Pi with Embedded Linux",
      videoUrl: "67f1094574ddd47d29d9844d",
      image: RaspberryPiwithEmbeddedLinux,
      completion: 0
    },
  ]
}
  ];

  const Automotiveapplications = [
    {
      category: "EMBEDDED",
      learningPath: "Embedded Systems for Automotive Applications",
      courses: [
    {
      courseId: 1,
      courseTitle: "Introduction to Embedded Systems",
      videoUrl: "67f0fb22e258a25e8f9a1eed",
      image: IntroductionEmbeddedSystems,
      completion: 0
    },
    {
      courseId: 2,
      courseTitle: "Practical C Programming",
      videoUrl: "67f0fbfc0eb36d149aa67a88",
      image: PracticalCProgramming,
      completion: 0
    },
    {
      courseId: 3,
      courseTitle: "Embedded Systems Security: Foundations, Secure Boot, and Cybersecurity",
      videoUrl: "67f10132eb2ffd5834742216",
      image: EmbeddedSystemsSecurity,
      completion: 0
    },
    {
      courseId: 4,
      courseTitle: "ARM Cortex-M Programming for Embedded Systems: STM32",
      videoUrl: "67f0fe73c4fd2505bce52199",
      image: ARMCortexMProgramming,
      completion: 0
    },
    {
      courseId: 5,
      courseTitle: "Advanced Peripherals: PWM, CAN, LIN, Ethernet",
      videoUrl: "67f10070e258a25e8f9a2327",
      image:  AdvancedPeripherals,
      completion: 0
    },
    {
      courseId: 6,
      courseTitle: "Real-Time Embedded Systems with FreeRTOS",
      videoUrl: "67f0ff4062f75f283817c01d", 
      image: RealTimeEmbeddedSystems,
      completion: 0
    },
    {
      courseId: 7,
      courseTitle: "Automotive Embedded Systems & Communication Protocols",
      videoUrl: "67f10ac07c760d7d98f4da90",
      image: AutomotiveEmbeddedSystems,
      completion: 0
    },
    {
      courseId: 8,
      courseTitle: "AUTOSAR & ECU Development: Architecture, Implementation, and Testing",
      videoUrl: "67f10b35cc31b9138bf6be86", 
      image: AUTOSARCUDevelopment,
      completion: 0
    },
    {
      courseId: 9,
      courseTitle: "Functional Safety & ADAS: ISO 26262 and Autonomous Vehicle Systems",
      videoUrl: "67f10bc4e2dc692b2a0e5218", 
      image: FunctionalSafetyADAS,
      completion: 0
    },
  ]
}
];

export { EmbeddedSystemsCourses, IoTEmbeddedSystems, EmbeddedLinux, 
  Automotiveapplications };